<nz-card nzTitle="Finalize Order<">

    <p>Confirm customer's email and finalize order.</p>
  
    <nz-card>
  
      <!-- Customer Email -->
      <div style="margin-bottom: 1rem;">
        <label>Customer Email <span style="color: red;">*</span></label>
        <input type="email" name="email" ngModel [email]="true" nz-input [(ngModel)]="email" placeholder="Enter valid email address" />
      </div>
  
      <!-- Confirmation Code -->
        <div style="margin-bottom: 1rem;" *ngIf="codeSent">
        <label>Confirmation Code <span style="color: red;">*</span></label>
            <input nz-input type="tel" inputmode="numeric" maxlength="4" [(ngModel)]="enteredPin" />
        </div>
  
      <!-- Send / Resend Code Button -->
      <div style="margin-top: 1rem;">
        <button nz-button nzType="primary" nzBlock [disabled]="resendCooldown > 0" (click)="sendCode()">
          {{ resendCooldown > 0 ? 'Resend (' + resendCooldown + 's)' : (codeSent ? 'Resend Code' : 'Email Code') }}
        </button>
      </div>
  
      <!-- Status Message -->
      <nz-alert style="margin: 10px;" *ngIf="pin" nzType="success" [nzMessage]="'Confirmation code has been sent to ' + email"></nz-alert>
  
    </nz-card>
  
    <!-- Finalize Order Button -->
    <div style="margin-top: 1.5rem;">
      <button nz-button nzType="primary" nzBlock [disabled]="!enteredPin || enteredPin.length < 4" (click)="submit()" [nzLoading]="confirmBtn">
        Finalize Order
      </button>
    </div>
  
  </nz-card>
  